import type { TemplateRequestFields } from '@tribeplatform/gql-client/graphql'
import type {
  QueryTemplateRequestArgs,
  TemplateRequest,
} from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getTemplateRequestKey } from '../../utils/keys/template.key.js'

export const useTemplateRequest = (options: {
  variables: QueryTemplateRequestArgs
  fields?: TemplateRequestFields
  useQueryOptions?: UseQueryOptions<TemplateRequest>
}) => {
  const { variables, fields, useQueryOptions } = options
  const { client } = useTribeClient()
  const templateRequestKey = getTemplateRequestKey({ variables, fields })

  return useQuery<TemplateRequest>(
    templateRequestKey,
    () => client.templates.templateRequest(variables, fields),
    {
      ...useQueryOptions,
    },
  )
}
